import React, { useEffect, useState } from "react";
import { Col, Collapse, Row } from "antd";
import { GoSmiley } from "react-icons/go";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";


import workBefore from '../../../../../assets/workBefore.png';
import workAfter from '../../../../../assets/workAfter.png';
import lunchimg from '../../../../../assets/lunchImg.png';
import styles from './pastScheduleCts.module.css';
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import ScheduleMiddleware from "../../../../../store/Middlewares/ScheduleMiddleware";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { IMG_URL } from "../../../../../store/Apis";
import dummyImg from '../../../../../assets/dummy.png';
import AlertAction from "../../../../../store/Actions/AlertActions";
import { BsEmojiWink } from "react-icons/bs";
import { GrEmoji } from "react-icons/gr";
import { BiSad } from "react-icons/bi";

const { Panel } = Collapse;

function PastScheduleCTS() {
  const [isActiveOne, setIsActiveOne] = useState(false);
  const [isActiveTwo, setIsActiveTwo] = useState(false);
  const customizeIcon = () => {
    if (isActiveOne == true) {
      return (
        <MdKeyboardArrowUp
          style={{
            color: "var(--secondary-color)",
            width: "50px",
            height: "50px",
          }}
        />
      );
    } else {
      return (
        <MdKeyboardArrowDown
          style={{
            color: "var(--secondary-color)",
            width: "50px",
            height: "50px",
          }}
        />
      );
    }
  };
  const customizeIconTwo = () => {
    if (isActiveTwo == true) {
      return (
        <MdKeyboardArrowUp
          style={{
            color: "var(--secondary-color)",
            width: "50px",
            height: "50px",
          }}
        />
      );
    } else {
      return (
        <MdKeyboardArrowDown
          style={{
            color: "var(--secondary-color)",
            width: "50px",
            height: "50px",
          }}
        />
      );
    }
  };

  useEffect(() => {
    getTaskSummary();
    getLanguage();
  }, [])

  const { state } = useLocation();
  const data = state;
  console.log('dataaaaa', data);
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [TaskDetail, setTaskDetail] = useState(null)
  const [ImageModal, setImageModal] = useState(false)
  const [SelectedImage, setSelectedImage] = useState(null)
  const [VideoModal, setVideoModal] = useState(false)
  const [SelectedVideo, setSelectedVideo] = useState(null)

  const dummyReporting = [
    {
      id: 1,
      heading: "Mood Reporting",
      text: "How’s Your Feeling After The Cleaning Service",
      icon: TaskDetail?.rating == 1 ? <BsEmojiWink size={20} color={'#56F71E'} />
        :
        TaskDetail?.rating == 2 ? <GoSmiley size={20} color={'#56F71E'} />
          :
          TaskDetail?.rating == 3 ? <GrEmoji size={20} color={'yellow'} />
            :
            TaskDetail?.rating == 4 ? <BiSad size={20} color={'red'} />
              : null
    },
    {
      id: 2,
      heading: "Add Note",
      text: TaskDetail?.note ? TaskDetail?.note : '---',
    },
    {
      id: 3,
      heading: "Problem Report",
      text: TaskDetail?.report_problem ? TaskDetail?.report_problem : '---',
    },
  ]

  const getTaskSummary = () => {
    dispatch(ScheduleMiddleware.getPastScheduleTaskSummary(data?.id))
      .then((data) => {
        setTaskDetail(data?.data)
      })
      .catch((err) => console.log(err))
  }

  const getLanguage = async () => {
    try {
      const language = localStorage.getItem('@selectedLanguage');
      i18n.changeLanguage(language)
    } catch (e) {
      console.log(e)
    }
  };


  return (
    <div className={styles.mainDiv}>
      <div className={styles.heading}>
        <h1>{t("Cleaner Task Summary")}</h1>
      </div>
      <Collapse
        className={styles.Collapse}
        expandIconPosition="end"
        onChange={() => setIsActiveOne(!isActiveOne)}
        expandIcon={() => customizeIcon()}
        ghost
      >
        <Panel className={styles.panel} header={<p className={styles.header}>{moment(TaskDetail?.date).format('MM-DD-YYYY')}</p>} key="1">
          {/* <div className={styles.panelOneHeader}>
            <span>Work Order</span>
            <p>10</p>
          </div> */}
          <Row className={styles.panelOneRow}>
            <Col className={styles.panelOneCol}>
              <span>{t("Customer Name")}</span>
              <p>{TaskDetail?.customer_name}</p>
            </Col>
            <Col className={styles.panelOneCol}>
              <span>{t("Cleaner Name")}</span>
              <p>{TaskDetail?.cleaner_name}</p>
            </Col>
            <Col className={styles.panelOneCol}>
              <span>{t("Location")}</span>
              <p>{TaskDetail?.location?.address}</p>
            </Col>
          </Row>
          <Row className={styles.panelOneRow}>
            <Col className={styles.panelOneCol}>
            <span>{t("Work Schedule")} </span>
              <p><span>{t("Assigned Time")}: </span>{moment(TaskDetail?.start_time, "h:mm:ss A").format('LT')} To {moment(TaskDetail?.end_time, "h:mm:ss A").format('LT')}</p>
              <p><span>{t("Completion Time")}: </span>{moment(TaskDetail?.time_in).format('LT')} To {moment(TaskDetail?.time_out).format('LT')}</p>
              <p><span>{t("Work Hours")}: </span>{TaskDetail?.working_hours}</p>
            </Col>
            <Col className={styles.panelOneCol}>
            <span>{t("Break Schedule")}</span>
              <p><span>{t("Assigned Time")}: </span>{moment(TaskDetail?.lunch_start_time).format('LT')} to {moment(TaskDetail?.lunch_end_time).format('LT')}</p>
              <p><span>{t("Completion Time")}: </span>{moment(TaskDetail?.break_in).format('LT')} To {moment(TaskDetail?.break_out).format('LT')}</p>
              <p><span>{t("Break Hours")}: </span>{TaskDetail?.break_hours ? TaskDetail?.break_hours : 'N/A'}</p>
            </Col>
            <Col className={styles.panelOneCol}>
            <span>{t("Status")} </span>
              <p>{TaskDetail?.status}</p>
            </Col>
          </Row>
          {/* <Row className={styles.panelOneRow} style={{width:'50%'}}>
            <Col className={styles.panelOneCol}>
              <span>{t("Break Hours")}</span>
              <p>{TaskDetail?.break_hours ? TaskDetail?.break_hours : 'N/A'}</p>
            </Col>
            <Col className={styles.panelOneCol}>
              <span>{t("Status")} </span>
              <p>{TaskDetail?.status}</p>
            </Col>
            <Col className={styles.panelOneCol}>
              <span>{t("Date")}</span>
              <p>{moment(TaskDetail?.date).format('MM-DD-YYYY')}</p>
            </Col>
          </Row> */}
        </Panel>
      </Collapse> <Collapse
        className={styles.Collapse}
        expandIconPosition="end"
        onChange={() => setIsActiveTwo(!isActiveTwo)}
        expandIcon={() => customizeIconTwo()}
        ghost

      >
        <Panel className={styles.panel} header={<p className={styles.header}>{t("Inventories")}</p>} key="1">
          {/* <h1 className={styles.panelTwoHeading}>{t("Inventories")}</h1> */}
          {data?.inventories?.length > 0 ? <div className={styles.panelTwolist}>
            {data?.inventories.map((item, index) => {
              return (
                <div className={styles.panelTwoRow}>
                  <div className={styles.panelTwoMainCol}>
                    <h1>{item?.name}</h1>
                  </div>
                  <div className={styles.panelTwoMainCol}>
                    <div className={styles.panelTwoSubMainCol}>
                      <span>{item?.quantity_used}</span>
                      <p>{t("Used")}</p>
                    </div>
                    <div className={styles.panelTwoSubMainCol}>
                      <span>{item?.quantity}</span>
                      <p>{t("Total")}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div> : <h1 className={styles.panelTwoHeading} style={{ textAlign: 'center' }}>No inventories found </h1>}
        </Panel>
      </Collapse>
      <div className={styles.reporting}>
        <div className={styles.reportingLeft}>
          <p>{t("Picture (Before and After work)")}</p>
          <div className={styles.subReportingLeft}>
            <div className={styles.workImg}>
              {data?.before_type?.match("video/*") || data?.before_type == "video"  ?
                <video autoPlay controls > <source src={IMG_URL + data?.before} /></video>
                :
                <a
                  href={IMG_URL + data?.before}
                  target="_blank"
                  title="Download"
                >
                  <img src={IMG_URL + data?.before} />
                </a>
              }
              <p>{t("Before")}</p>
              <span onClick={() => {
                !data?.time_in_latitude && !data?.time_in_longitude ?
                  dispatch(AlertAction.ShowAlert({ type: "error", message: "No location found" })) :
                  navigate("/cleanerTaskSummary/CleanerTaskSummary/Map", { state: { latitude: data?.time_in_latitude, longitude: data?.time_in_longitude } })
              }}>{t("View Map")}</span>
            </div>
            <div className={styles.workImg}>
              {data?.after_type == 'video' || data?.after_type?.match("video/*")  ?
                // <iframe src={IMG_URL + data?.after} ></iframe>
                <video autoPlay controls > <source src={IMG_URL + data?.after} /></video>
                :
                <a
                  href={IMG_URL + data?.after}
                  target="_blank"
                  title="Download"
                >
                  <img src={IMG_URL + data?.after} />
                </a>
              }
              <p>{t("After")}</p>
              <span onClick={() => {
                !data?.time_out_latitude && !data?.time_out_longitude ?
                  dispatch(AlertAction.ShowAlert({ type: "error", message: "No location found" })) :
                  navigate("/cleanerTaskSummary/CleanerTaskSummary/Map", { state: { latitude: data?.time_out_latitude, longitude: data?.time_out_longitude } })
              }}>{t("View Map")}</span>
            </div>
          </div>
          <p>{t("Lunch Break")}</p>
          <div className={styles.subReportingLeft}>
            <div className={styles.lunchCon}>
              <div className={styles.lunchImg}>
                <a
                  href={data?.after_lunch_image ? IMG_URL + data?.after_lunch_image : null}
                  target="_blank"
                  title="Download"
                >
                  <img src={data?.after_lunch_image ? IMG_URL + data?.after_lunch_image : dummyImg} />
                </a>
              </div>
              <p></p>
              <span onClick={() => {
                !data?.lunch_out_latitude && !data?.lunch_out_longitude ?
                  dispatch(AlertAction.ShowAlert({ type: "error", message: "No location found" })) :
                  navigate("/cleanerTaskSummary/CleanerTaskSummary/Map", { state: { latitude: data?.lunch_out_latitude, longitude: data?.lunch_out_longitude } })
              }}>{t("View Map")}</span>
            </div>
          </div>
        </div>
        <div className={styles.reportingRight}>
          {dummyReporting.map((item, index) => {
            return (
              <div className={styles.reportingItem} key={index}>
                <h1>{t(item?.heading)}</h1>
                <text>{item?.text}</text>
                {item?.heading == "Mood Reporting" ? item?.icon : null}

              </div>
            )
          })}
        </div>
      </div>
    </div>

  );
}

export default PastScheduleCTS;
